export default {
    title: 'Locations',
    subtitle: 'Locations list',
    createLocation: 'Create Location',
    createSubtitle: 'Add a new location to track resource placement',
    editLocation: 'Edit Location',
    editTitle: 'Edit Location',
    editSubtitle: 'Update location information',
    createSuccess: 'Location created successfully',
    createError: 'Failed to create location',
    updateSuccess: 'Location updated successfully',
    updateError: 'Failed to update location',
    loadError: 'Failed to load location',
    notFound: 'Location not found',
    locationForm: {
        name: 'Location Name',
        nameRequired: 'Location name is required',
        nameMinLength: 'Location name cannot be empty',
        namePlaceholder: 'Enter location name',
        description: 'Description',
        descriptionPlaceholder: 'Enter location description',
        notes: 'Notes',
        notesPlaceholder: 'Additional notes about this location'
    },
    locationsAdmin: {
        createTitle: 'Create Location',
        editTitle: 'Edit Location',
        deleteTitle: 'Delete Location',
        createSuccess: 'Location created successfully',
        updateSuccess: 'Location updated successfully',
        deleteSuccess: 'Location deleted successfully',
        createError: 'Failed to create location',
        updateError: 'Failed to update location',
        deleteError: 'Failed to delete location',
        deleteConfirmation: 'Are you sure you want to delete this location? This action cannot be undone.'
    }
};
